import { render, staticRenderFns } from "./EditCommentDialog.vue?vue&type=template&id=d1740f96&scoped=true&"
import script from "./EditCommentDialog.vue?vue&type=script&lang=js&"
export * from "./EditCommentDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCommentDialog.vue?vue&type=style&index=0&id=d1740f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1740f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
